import React from "react";
import { Button } from "primereact/button";
import Image from "../../assets/img/ellipsis.gif";

const ButtonAdminLoader = () => {
  return (
    <Button className="p-button-lg p-button-disabled" disabled>
      <img src={Image} alt="loading..." />
    </Button>
  );
};

export default ButtonAdminLoader;
